import React from "react";
import { styled } from "styled-components";
import { Footer } from "../Footer";
import { LayoutProps } from "..";
import { Card } from "./Card";

export const Content: React.FC<LayoutProps> = ({
  children,
  className,
  cardProps,
  belowContent,
}) => {
  return (
    <>
      <Container {...(className && { className })}>
        <>
          <Card {...cardProps}>{children}</Card>
          {belowContent}
        </>
      </Container>
      <Footer />
      <Background />
    </>
  );
};

type BackgroundProps = {
  mobile?: string;
  desktop?: string;
};

const Background = styled.div<BackgroundProps>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  background-position: center;
  background-size: cover;
  z-index: 0;
  background-color: #07092b;
  background-image: url(https://storage.googleapis.com/set-live.appspot.com/set-live/signup/set-neon-swirl-background.jpg);

  ${({ theme }) => theme.media.mobile} {
    background-image: url(https://storage.googleapis.com/set-live.appspot.com/set-live/signup/set-neon-swirl-background-mobile.jpg);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 64px;
  padding-top: 44px;
  z-index: 1;
  transition: all 0.3s ease-in-out;

  ${({ theme }) => theme.media.maxTablet} {
    padding: 44px;
    padding-top: 32px;
  }

  ${({ theme }) => theme.media.mobile} {
    padding: 20px 20px 32px;
    justify-content: center;
  }
`;
